"use client";

import Image from "next/image";
import { Button } from "@/components/ui/button";
import { useIntl } from "react-intl";
import { useDispatch} from "react-redux";
import { openModal } from "@/slice/whatsappModalSlice";

export default function Guidance() {
  const intl = useIntl();
  const dispatch = useDispatch();

  return (
    <>
      <style>{`
        .guidance-section-bg {
          background-color: #FBFDFF;
          width: 100%;
          overflow-x: clip;
        }
        .guidance-section {
          /* Tight gap from hero above */
          padding: 0 1rem 3.5rem;
          max-width: 1440px;
          margin: 0 auto;
          overflow-x: clip;
        }
        @media (max-width: 768px) {
          .guidance-section {
            padding: 0 1rem 2.5rem;
          }
        }
        .guidance-container {
          width: 100%;
          max-width: 1280px;
          display: flex;
          flex-wrap: wrap;
          gap: 4.5rem;
          align-items: stretch;
          justify-content: flex-start;
          margin: 0 auto;
        }
        @media (max-width: 768px) {
          /* On mobile keep image to the left of the text in a compact two-column layout */
          .guidance-container {
            flex-direction: column-reverse;
            flex-wrap: nowrap;
            gap: 0.5rem;
            align-items: flex-start;
            justify-content: flex-start;
          }
        }
        .guidance-image-wrapper {
          display: flex;
          justify-content: center;
          padding: 1.5rem;
          margin-top: 8rem;
          overflow-x: clip;
        }
        @media (max-width: 768px) {
          .guidance-image-wrapper {
            /* position image on the left */
            justify-content: flex-start;
            width: 88%;
            padding: 0.25rem 0.75rem 0.25rem 0;
            margin-top: 1.5rem;
          }
        }
        .guidance-image-container {
          width: 500px;
          height: auto;
          position: relative;
          overflow-x: clip;
        }
        @media (max-width: 1024px) {
          .guidance-image-container {
            width: clamp(420px, 46vw, 500px);
          }
        }
        @media (max-width: 768px) {
          .guidance-image-container {
            /* increase mobile image size while keeping it responsive */
            width: 90%;
            max-width: 450px;
            height: auto;
          }
        }
        .guidance-image {
          width: 100%;
          height: auto;
          display: block;
        }
        @media (max-width: 1024px) {
          .guidance-image {
            max-width: clamp(420px, 46vw, 500px);
          }
        }
        @media (max-width: 768px) {
          .guidance-image {
            width: 100%;
            max-width: 420px;
            height: auto;
            display: block;
          }
        }
        /* Decorative background rectangles positioned behind the main image */
        .guidance-rect-left,
        .guidance-rect-right {
          position: absolute;
          top: -38px;
          width: 280px;
          height: 360px;
          z-index: 0;
          pointer-events: none;
          opacity: 0.9;
        }
        .guidance-rect-left {
          left: -46px;
        }
        .guidance-rect-right {
          right: -36px;
        }
        /* make sure the main illustration sits above the decorative shapes */
        .guidance-image {
          position: relative;
          z-index: 1;
        }
        @media (max-width: 1024px) {
          .guidance-rect-left,
          .guidance-rect-right {
            top: -48px;
            width: 110px;
          }
        }
        @media (max-width: 768px) {
          .guidance-rect-left,
          .guidance-rect-right {
            /* move higher so they sit behind the top part of the illustration */
            top: -48px;
            width: 120px;
          }
          .guidance-rect-left {
            left: -12px;
            right: auto;
          }
          .guidance-rect-right {
            right: -12px;
            left: auto;
          }
        }
        @media (max-width: 480px) {
          .guidance-rect-left,
          .guidance-rect-right {
            /* stronger upward offset on very small screens */
            top: -97px;
            width: 40%;
            max-width: 180px;
          }
          .guidance-rect-left {
            left: 6%;
          }
          .guidance-rect-right {
            right: 6%;
          }
        }
        .guidance-content {
          flex: 1 1 260px;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        @media (max-width: 768px) {
          .guidance-content {
            width: 100%;
            max-width: 100%;
            padding: 2px 0;
            justify-content: flex-start;
            box-sizing: border-box;
            margin-top: 0;
          }
        }
        .guidance-heading {
          display: block;
          font-family: "Roboto Slab", serif;
          font-size: 32px;
          line-height: 50px;
          letter-spacing: 0.04em;
          // margin: 0 0 0.75rem 0;
        }
        @media (max-width: 768px) {
          .guidance-heading {
            font-size: 24px;
            line-height: 32px;
          }
        }
        .guidance-paragraph {
          // margin: 0 0 0.9rem ;
          font-family: "Roboto", sans-serif;
          font-weight: 500;
          font-style: italic;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: 0.02em;
          color: #00428A;
          max-width: 36rem;
        }
        @media (max-width: 768px) {
          .guidance-paragraph {
            font-size: 14px;
            line-height: 22px;
            max-width: 100%;
          }
        }
        .guidance-subheading {
          font-family: "Roboto", sans-serif;
          font-weight: 700;
          font-size: 18px;
          line-height: 26px;
          letter-spacing: 0.04em;
          color: #00428A;
          // margin: 0.25rem 0 0.25rem 0;
          
        }
        @media (max-width: 768px) {
          .guidance-subheading {
            font-size: 16px;
            line-height: 22px;
          }
        }
        .guidance-button-wrapper {
          width: fit-content;
          min-width: 220px;
          max-width: 280px;
          height: 48px;
          border-radius: 9999px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 30%;
          margin-right: auto;
          margin-top: 6px;
          

        }
        .guidance-button-wrapper button {
          transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
          white-space: nowrap;
          overflow: visible;
          word-break: keep-all;
        }
        .guidance-button-wrapper button:hover {
          background-color: #00428A !important;
          color: #FFFFFF !important;
          border-color: #00428A !important;
        }
        @media (max-width: 768px) {
          .guidance-button-wrapper {
            width: 100%;
            max-width: 360px;  
            height: auto;
            min-height: 45px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          }
          .guidance-button-wrapper button {
            white-space: normal;
            word-wrap: break-word;
            padding: 8px 16px;
            line-height: 1.4;
            overflow: visible;
            text-overflow: clip;
          }
        }
        .guidance-list-item {
          margin-bottom: 0.75rem;
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.04em;
          color: #404248;
          padding-left: 1.5rem;
          position: relative;
        }
        @media (max-width: 768px) {
          .guidance-list-item {
            font-size: 13px;
            line-height: 22px;
            margin-bottom: 0.5rem;
          }
        }
      `}</style>
      <section className="guidance-section-bg">
        <div className="guidance-section">
          <div className="guidance-container">
            <div className="guidance-image-wrapper">
              <div className="guidance-image-container">
                <Image
                  src="/images/Guidance-Rectangle.svg"
                  alt={intl.formatMessage({
                    id: "guidance.imageAlt",
                    defaultMessage: "Guidance illustration",
                  })}
                  width={260}
                  height={160}
                  className="guidance-rect-left"
                />
                <Image
                  src="/images/Guidance_Rectangle2.svg"
                  alt={intl.formatMessage({
                    id: "guidance.imageAlt",
                    defaultMessage: "Guidance illustration",
                  })}
                  width={160}
                  height={160}
                  className="guidance-rect-right"
                />
                <Image
                  src="/images/Families.svg"
                  alt={intl.formatMessage({
                    id: "guidance.imageAlt",
                    defaultMessage: "Guidance illustration",
                  })}
                  width={480}
                  height={480}
                  className="guidance-image"
                />
              </div>
            </div>

            <div className="guidance-content">
              <h2 className="guidance-heading">
                <span
                  style={{
                    fontWeight: 200,
                    color: "#404248",
                  }}
                >
                  {intl.formatMessage({
                    id: "guidance.headingRegular",
                    defaultMessage: "We help families decide",
                  })}
                </span>
                <span
                  style={{
                    fontWeight: 700,
                    color: "#00428A",
                  }}
                >
                  {intl.formatMessage({
                    id: "guidance.headingBold",
                    defaultMessage: "not just find treatment",
                  })}
                </span>
              </h2>
              <p className="guidance-paragraph">
                {intl.formatMessage({
                  id: "guidance.paragraph",
                  defaultMessage:
                    "Close to home or anywhere in the world — wherever it’s best for you",
                })}
              </p>

              <div style={{ marginTop: "4px" }}>
                <h3 className="guidance-subheading">
                  {intl.formatMessage({
                    id: "guidance.whatWeDo",
                    defaultMessage: "What we do",
                  })}
                </h3>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: "0 0 0.75rem 0",
                  }}
                >
                  <li className="guidance-list-item">
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: "0.5rem",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#404248",
                      }}
                    />
                    {intl.formatMessage({
                      id: "guidance.whatWeDoItem1",
                      defaultMessage:
                        "Explain doctor and treatment options in simple terms",
                    })}
                  </li>
                  <li className="guidance-list-item">
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: "0.5rem",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#404248",
                      }}
                    />
                    {intl.formatMessage({
                      id: "guidance.whatWeDoItem2",
                      defaultMessage:
                        "Share pros, risks, and alternatives honestly",
                    })}
                  </li>
                  <li className="guidance-list-item">
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: "0.5rem",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#404248",
                      }}
                    />
                    {intl.formatMessage({
                      id: "guidance.whatWeDoItem3",
                      defaultMessage:
                        "Support second opinions when helpful",
                    })}
                  </li>
                </ul>
              </div>

              <div style={{ marginBottom: "12px", marginTop: "2px" }}>
                <h3 className="guidance-subheading">
                  {intl.formatMessage({
                    id: "guidance.whatWeDontDo",
                    defaultMessage: "What we don't do",
                  })}
                </h3>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                  }}
                >
                  <li className="guidance-list-item">
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: "0.5rem",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#404248",
                      }}
                    />
                    {intl.formatMessage({
                      id: "guidance.whatWeDontDoItem1",
                      defaultMessage: "Push hospitals, doctors, or packages",
                    })}
                  </li>
                  <li className="guidance-list-item">
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: "0.5rem",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#404248",
                      }}
                    />
                    {intl.formatMessage({
                      id: "guidance.whatWeDontDoItem2",
                      defaultMessage: "Create urgency or pressure",
                    })}
                  </li>
                </ul>
              </div>

              {/* change whatsapp modal headline  */}
              <div className="guidance-button-wrapper">
                <Button
                  variant="outline"
                  onClick={()=>dispatch(openModal())}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "36px",
                    border: "1px solid #00428A",
                    color: "#00428A",
                    padding: "8px 20px",
                    fontSize: "0.9rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {intl.formatMessage({
                    id: "guidance.buttonLabel",
                    defaultMessage: "Get honest guidance",
                  })}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}